<template>
  <div
    :class="[
      'notification-banner',
      `notification-banner_${background}`
    ]"
  >
    <div v-if="$route.path === '/'" class="notification-banner__margin" />
    <div class="notification-banner__text" v-html="msg" />
  </div>
</template>

<script>
  export default {
    name: 'NotificationBanner',
    props: {
      msg: {
        type: String,
        required: true
      },
      background: {
        type: String,
        default: 'gray'
      }
    }
  }
</script>

<style lang="scss">
  .notification-banner {
    transition: all 0.5s cubic-bezier(0.17, 0.67, 0.55, 1.1);

    &_red {
      background-color: rgba($c-active, 0.12);
    }

    &_gray {
      background-color: rgba($c-gray, 0.2);
    }

    &__margin {
      height: 60px;
      background-color: $c-white;

      @include mobile {
        height: 40px;
      }
    }

    &__text {
      padding: 40px 33px;
      margin: 0 auto;

      &,
      * {
        font-family: "FavoritBookC", Arial, Helvetica, sans-serif;
        font-size: 17px;
        line-height: 24px;
        color: $c-black;
        text-align: center;

        @include mobile {
          font-size: 15px;
          line-height: 21px;
        }
      }

      strong {
        font-weight: bold;
      }

      em {
        font-style: italic;
      }

      sup {
        vertical-align: super;
      }

      sub {
        vertical-align: sub;
      }

      h1 {
        font-size: 2.2em;
      }

      h2 {
        font-size: 2em;
      }

      h3 {
        font-size: 1.8em;
      }

      h4 {
        font-size: 1.6em;
      }

      h5 {
        font-size: 1.4em;
      }

      h6 {
        font-size: 1.2em;
      }

      p,
      ol,
      ul,
      h1,
      h2,
      h3,
      h4,
      h5,
      h6 {
        margin-bottom: 20px;

        &:last-child {
          margin-bottom: 0;
        }
      }

      li {
        list-style: inside;
      }

      ol {
        li {
          list-style: inside decimal;
        }
      }
    }
  }
</style>
